import React, { useState, useEffect } from 'react';
import VerticalDatePicker from './VerticalDatePicker';
import { useDispatch, useSelector } from 'react-redux';
import { changeHiringStatus } from "../../services/operations/JobPostAPI";

const InterviewSchedulePopup = ({ isOpen, onClose, detail, data, fetchDetails }) => {
  const [selectedDate, setSelectedDate] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [error, setError] = useState('');
  const [isEndTimeManuallyChanged, setIsEndTimeManuallyChanged] = useState(false);

  const token = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isOpen) {
      const now = new Date();

      const start = now.toTimeString().slice(0, 5); 
      const endDate = new Date(now.getTime() + 60 * 60000);
      const end = endDate.toTimeString().slice(0, 5);

      setSelectedDate(now);
      setStartTime(start);
      setEndTime(end);
      setIsEndTimeManuallyChanged(false);
      setError('');
    } else {
      setSelectedDate('');
      setStartTime('');
      setEndTime('');
      setIsEndTimeManuallyChanged(false);
      setError('');
    }
  }, [isOpen]);

  useEffect(() => {
    if (startTime && !isEndTimeManuallyChanged) {
      const [h, m] = startTime.split(':').map(Number);
      const start = new Date();
      start.setHours(h);
      start.setMinutes(m);
      start.setSeconds(0);

      const endDate = new Date(start.getTime() + 60 * 60000); // +1 hour
      const endH = String(endDate.getHours()).padStart(2, '0');
      const endM = String(endDate.getMinutes()).padStart(2, '0');
      setEndTime(`${endH}:${endM}`);
    }
  }, [startTime, isEndTimeManuallyChanged]);

  const handleSubmit = async () => {
    setError('');

    if (!selectedDate || !startTime || !endTime) {
      setError('Please fill all fields.');
      return;
    }

    const [startH, startM] = startTime.split(':').map(Number);
    const [endH, endM] = endTime.split(':').map(Number);

    const startMinutes = startH * 60 + startM;
    const endMinutes = endH * 60 + endM;

    if (startMinutes >= endMinutes) {
      setError('End time must be after start time.');
      return;
    }

    const payload = {
      job_id: data.jobId,
      candidate_id: data.id,
      status: detail?.next_status,
      start_time: startTime,
      end_time: endTime,
      date: selectedDate.toISOString().split("T")[0],
    };

    await dispatch(changeHiringStatus(payload, token));
    fetchDetails();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="interview-schedule-popup-overlay">
      <div className="interview-schedule-popup-card">
        <div className="interview-schedule-popup-header">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', alignItems: 'flex-start' }}>
            <h2>Choose your preferred date and time for interview</h2>
            <p>Fill up the following detail to schedule interview</p>
          </div>
          <button className="interview-schedule-close-btn" onClick={onClose}>×</button>
        </div>

        <div className="interview-schedule-popup-body">
          <div>
            <p className="date-wrapper-head">Select Date</p>
            <VerticalDatePicker onDateSelect={setSelectedDate} />
          </div>

          <div className="interview-schedule-time-section">
            <div className="time-section-div">
              <label>Start time</label>
              <div className="interview-schedule-time-input">
                <input
                  type="time"
                  value={startTime}
                  onChange={(e) => {
                    setStartTime(e.target.value);
                    setIsEndTimeManuallyChanged(false);
                  }}
                />
              </div>
              {error && <p className="interivew-schedule-form-error">{error}</p>}
            </div>

            <div className="time-section-div">
              <label>End Time</label>
              <div className="interview-schedule-time-input">
                <input
                  type="time"
                  value={endTime}
                  onChange={(e) => {
                    setEndTime(e.target.value);
                    setIsEndTimeManuallyChanged(true);
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="interview-schedule-popup-footer">
          <button
            className="interview-schedule-submit-btn"
            onClick={handleSubmit}
            disabled={!selectedDate || !startTime || !endTime}
            style={{
              backgroundColor: selectedDate && startTime && endTime
                ? "rgba(94, 150, 255, 1)"
                : "rgba(205, 222, 255, 0.43)",
              cursor: selectedDate && startTime && endTime ? "pointer" : "not-allowed",
              color: selectedDate && startTime && endTime ? "white" : "rgba(0, 0, 0, 0.5)"
            }}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default InterviewSchedulePopup;